export default __webpack_public_path__ + "68f486a18250ef266a584ea5c24b6f56.png";